import React from "react";
import '../../scss/home/operatorDetail.scss';

const OperatorDetail = () => {
  return (
    <div className="operator-detail">
      <div className="container">
        <div className="operator-text">
         <p>
          We have more then 200 bus operator partners in Nepal and 400 truck
          renters as well as 200 mini car operator in Nepal from different
          districts
        </p>
        </div>
      </div>
    </div>
  );
};

export default OperatorDetail;
